import React from 'react';
import {
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Box,
  Typography,
  Chip,
  Divider,
} from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { Feed } from '../../api/models/Feed';
import { ProvisioningStatus } from '../../api/models/ProvisioningStatus';

interface FeedsRowProps {
  feed: Feed;
  index: number;
  totalFeeds: number;
  isLoading: boolean;
  onDeleteFeed: (feedName: string) => void;
}

const FeedsRow: React.FC<FeedsRowProps> = ({
  feed,
  index,
  totalFeeds,
  isLoading,
  onDeleteFeed,
}) => {
  const isPendingStatus = (status: string): boolean =>
    status.toLowerCase() === ProvisioningStatus.PENDING;

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case ProvisioningStatus.PENDING:
        return 'warning';
      case ProvisioningStatus.ACTIVE:
        return 'success';
      default:
        return 'default';
    }
  };

  return (
    <>
      <ListItem>
        <ListItemText
          primary={
            <>
              <Typography variant="subtitle1" component="span" sx={{ marginRight: 1 }}>
                {feed.feedName}
              </Typography>
              <Chip
                label={feed.status}
                size="small"
                color={getStatusColor(feed.status) as any}
              />
            </>
          }
          secondary={
            <>
              <Typography variant="body2" color="text.secondary" component="span">
                Scope: {feed.feedScope}
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary" component="span">
                Created by: {feed.createdBy}
              </Typography>
              <br />
              <Typography variant="body2" color="text.secondary" component="span">
                Created on: {new Date(feed.createdOn).toLocaleDateString()}
              </Typography>
            </>
          }
          primaryTypographyProps={{ component: 'div' }}
          secondaryTypographyProps={{ component: 'div' }}
        />
        <ListItemSecondaryAction>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              edge="end"
              onClick={() => onDeleteFeed(feed.feedName)}
              disabled={isLoading || isPendingStatus(feed.status)}
              title={isPendingStatus(feed.status) ? 'Cannot delete pending feeds' : 'Delete feed'}
            >
              <DeleteOutline />
            </IconButton>
          </Box>
        </ListItemSecondaryAction>
      </ListItem>
      {index < totalFeeds - 1 && <Divider />}
    </>
  );
};

export default FeedsRow;
